<script>
import CommonConstants from '../../common/Constants';

import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Toolbar from 'primevue/toolbar';
import Dialog from 'primevue/dialog';
import GenericCustomMasterDataSelect from '../../components/generic/GenericCustomMasterDataSelect.vue'
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'

import Service from '../../services/movement-instruction';
import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default{
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Toolbar, Dialog, Card, DataTable, Column, 
    GenericCustomMasterDataAutocompleteV2, 
    ResponsiveButton, InputText, GenericCustomMasterDataSelect
  },
  props: ['id', 'readOnly', 'proposal', 'lotCode'],
  data(){
    return {
      submitted: false,
      measureItemDisabled: false,
      items: [],
      measureDialogVisible: false,
      measureItem:{
        description: null,
        uoMCode: null
      }
    }
  },
  validations(){
    return {
      measureItem: {
        description: {required},
        uoMCode: {required}
      }
    }
  },
  mounted(){
    if(this.id){
      this.loadData();
    }
  },
  computed: {
      uiPermissions(){
        return this.$store.getters['security/uiPermissions'];
      },
      constants(){
          return CommonConstants;
      },
      lotProposal(){
        if(this.proposal && this.proposal.parcels && this.proposal.parcels.length > 0){
          let p = this.proposal.parcels.find(x => x.movementInstructionLotCode == this.lotCode);
          return p;
        }
        return {};
      }
  },
  methods: {
    reload(){
      this.loadData();
    },
    loadData(){
      let filters = [
        {
          operator: 'eq',
          value: this.id,
          property: 'IdMovementInstructionLot'
        }
      ];
      let params = {
          filter: JSON.stringify(filters),
      }

      Service.getMeasureUnits(params, response => {
        if(response.success){
          this.items = response.data;
        }
      });
    },

    submitSaveMeasureUnit(){
      this.submitted = true;
      if(!this.v$.$invalid){
        this.measureItemDisabled = true;
        if(this.measureItem.id){
          Service.updateMeasureUnit(this.measureItem, 
            response => {
              this.submitted = false;
              this.measureItemDisabled = false;
              if(response.success){
                this.loadData();
                this.measureDialogVisible = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }else{
          Service.createMeasureUnit(this.measureItem, 
            response => {
              this.submitted = false;
              this.measureItemDisabled = false;
              if(response.success){
                this.loadData();
                this.measureDialogVisible = false;
                this.submitted = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }
      }
    },
    onDeleteMeasureUnit(data, event){
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('messages.delete_message_question'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
            Service.deleteMeasureUnit(data.id, 
              response => {
                if(response.success){
                  this.loadData();
                  this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                }
                else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
              }
            )
        },
        reject: () => {
            //callback to execute when user rejects the action
            this.$confirm.close();
        }
      });
    },
    openMeasureUnitDialog(){
      this.measureItem = {
        idMovementInstructionLot: this.id,
        description: null,
        uoMCode: null
      }
      this.measureDialogVisible = true;
    },
    openMeasureUnitDialogEdit(data){
      this.measureItem = {...data};
      this.measureDialogVisible = true;
    },
    onUnitOfMeasureSelected(e){
      this.measureItem.description = e.extraData.description;
    },
    openProposal(e){
      this.$refs.proposalop.toggle(e);
    },
    
    checkUom(item){
      let found = this.items.find(i => i.uoMCode == item.uomCode);
      return found;
    },
    applySaveUom(item){
      let found = this.checkUom(item);
      if(found){
          this.$confirm.require({
          message: this.$t('messages.item_exists_replace_message'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this.$t('yes'),
          rejectLabel: this.$t('no'),
          accept: () => {

            this.measureItem = {
              id: found.id,
              idMovementInstructionLot: this.id,
              description: item.uom,
              uoMCode: item.uomCode
            }
            this.submitSaveMeasureUnit();

            this.$confirm.close();
          },
          reject: () => {
              //callback to execute when user rejects the action
              this.$confirm.close();
          }
        });
      }else{

        this.measureItem = {
          idMovementInstructionLot: this.id,
          description: item.uom,
          uoMCode: item.uomCode
        }
        this.submitSaveMeasureUnit();
      }
    },
  }
}
</script>

<style scoped>
.custom-card-title{
  font-size: 18px;
}
</style>
<template>
  <main>
    <OverlayPanel ref="proposalop">
      <DataTable :reorderableColumns="true" :value="lotProposal.billofLadingUoM" showGridlines stripedRows dataKey="idRegistryDocument">
        <Column  v-if="!readOnly">
            <template #body="element">
                <ResponsiveButton :label="$t('btn.apply')" icon="pi pi-check" class="p-button-text" @click="applySaveUom(element.data)"/>
            </template>
          </Column>
        <Column :header="'Già inserito'">
          <template #body="element">
            {{  checkUom(element.data) ? $t('yes') : $t('no') }}
            <!-- {{ element.data.toSend }} -->
          </template>
        </Column>
        <Column field="uom" :header="$t('description')" >
            <template #body="element">
              {{ element.data.uom }}
            </template>
          </Column> 
          <Column field="uomCode" :header="$t('unitofMeasureCode')"  v-if="!readOnly" >
            <template #body="element">
              <generic-custom-master-data-autocomplete-v-2 
                v-model="element.data.uomCode"
                    name="units-of-measure"
                api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=MovementInstruction"
                :format="{label: 'code', value: 'code' }" sortField="Code"
                :class="{'p-inputtext-sm mt-1 ': true}" />
            </template>
          </Column>
        </DataTable>
    </OverlayPanel>
    <div class="grid">
      <div class="col-12">
        <div class="card">
          <div class="grid">
            <Card class="col-12" >
              <template #content>
                <Dialog v-model:visible="measureDialogVisible" modal class="p-fluid">
                  <div class="field">
                    <label :class="{'p-error':v$.measureItem.uoMCode.$invalid && submitted}">{{$t('unitofMeasureCode')}}</label>
                    <generic-custom-master-data-autocomplete-v-2 :disabled="readOnly"
                    :disableFirstChangeFn="true"
                    v-model="measureItem.uoMCode"
                    name="units-of-measure"
                    :changeFn="onUnitOfMeasureSelected"
                    api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=MovementInstruction"
                    :format="{ label: 'code', value: 'code' }" sortField="Code"
                    :class="{'p-invalid':v$.measureItem.uoMCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.measureItem.uoMCode.$invalid && submitted) || v$.measureItem.uoMCode.$pending.$response">
                      <small class="p-error" v-for="error in v$.measureItem.uoMCode.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                      </small>
                    </div>
                  </div>
                  <div class="field">
                      <label :class="{'p-error':v$.measureItem.description.$invalid && submitted}">{{$t('description')}}</label>
                      <InputText :disabled="readOnly"
                          v-model="measureItem.description"
                        :class="{'p-invalid':v$.measureItem.description.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.measureItem.description.$invalid && submitted) || v$.measureItem.description.$pending.$response">
                          <small class="p-error" v-for="error in v$.measureItem.description.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                    <template #footer>
                      <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="measureDialogVisible = false"/>
                      <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSaveMeasureUnit" :disabled="measureItemDisabled" />
                    </template>
                </Dialog>
                <div class="grid mt-4">
                  <div class="col-12">
                    <DataTable :value="items" showGridlines stripedRows :reorderableColumns="true">
                        <template #header>
                          <Toolbar>
                            <template #start>
                                <div class="custom-card-title">{{$t('movementInstructions.measureUnits')}}</div>
                                <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event)" class="p-button-warning mt-1"  v-if="proposal && lotProposal && lotProposal.billofLadingUoM" />
                              </template>

                            <template #end>
                               <ResponsiveButton :label="$t('btn.add')" :disabled="!uiPermissions('MovementInstruction.Lot.MeasureUnit').isEnabled || readOnly" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openMeasureUnitDialog"  />
                              </template>
                        </Toolbar>
                       </template>
                        <Column :exportable="false" style="min-width:8rem" :reorderableColumn="false">
                          <template #body="slotProps">
                              <ResponsiveButton icon="pi pi-pencil" :disabled="!uiPermissions('MovementInstruction.Lot.MeasureUnit').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="openMeasureUnitDialogEdit(slotProps.data)" />
                              <ResponsiveButton icon="pi pi-trash" :disabled="!uiPermissions('MovementInstruction.Lot.MeasureUnit').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDeleteMeasureUnit(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="description" :header="$t('description')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.description}}
                            </template>
                          <template #editor="{ data, field }">
                            <InputText v-model="data[field]" autofocus />
                          </template>
                        </Column>
                        <Column field="uoMCode" :header="$t('unitofMeasureCode')" dataType="string" :sortable="true">
                          <template #body="element">
                            {{element.data.uoMCode}}
                          </template>
                          <template #editor="{ data, field }">
                            <GenericCustomMasterDataSelect :disabled="readOnly" class="w-full p-inputtext-sm mt-1 "
                              name="units-of-measure"
                              v-model="data[field]" 
                              api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=MovementInstruction"
                              :format="{label: 'code', value: 'code' }" sortField="Code" />
                          </template>
                        </Column>
                        <template #empty>
                          {{$t('noRecordsFound')}}
                        </template>
                    </DataTable>
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
